"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = require("styled-components");
var _withIcon = _interopRequireDefault(require("./withIcon"));
const ArrowRightPrizm = props => _react.default.createElement("svg", (0, _extends2.default)({
  width: "32",
  height: "32",
  viewBox: "0 0 32 32"
}, props), _react.default.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M6 17a1 1 0 1 1 0-2h17.586l-5.293-5.293a1 1 0 0 1 1.414-1.414l7 7a1 1 0 0 1 0 1.414l-7 7a1 1 0 0 1-1.414-1.414L23.586 17H6Z"
}));
const ArrowRightMDS = props => _react.default.createElement("svg", (0, _extends2.default)({
  width: "16",
  height: "16",
  viewBox: "0 0 16 16"
}, props), _react.default.createElement("path", {
  fill: "currentColor",
  d: "M9.3 1.3L7.9 2.7 12.2 7H0v2h12.2l-4.3 4.3 1.4 1.4L16 8z"
}));
const AbstractArrowRight = ({
  theme,
  ...other
}) => theme.name === 'mds' ? _react.default.createElement(ArrowRightMDS, other) : _react.default.createElement(ArrowRightPrizm, other);
var _default = exports.default = (0, _styledComponents.withTheme)((0, _withIcon.default)('ArrowRight')(AbstractArrowRight));